// extracted by mini-css-extract-plugin
export default {"content":"content_content__bq2tU","main":"content_main__Svqtt","appear":"content_appear__hvR7R"};